import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { createOrdersApi, orderKeys } from '../api';
import type { OrderHistoryResult } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UseOrderStatusHistoryOptions {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Lifecycle history — a status page plus the `created` sentinel (fetched separately so a full
 * status page never pushes the sentinel, and the first stable status it carries, out of range) —
 * used to feed the lifecycle timeline independently of the capped mixed feed.
 */
export function useOrderStatusHistory(
  id: string,
  options: UseOrderStatusHistoryOptions = {},
): UseQueryResult<OrderHistoryResult> {
  const { enabled = true } = options;
  const client = useApiClient('deliveries');
  const api = createOrdersApi(client);

  return useQuery({
    enabled: enabled && id.length > 0,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.getOrderStatusHistory(id),
    queryKey: orderKeys.statusHistory(id),
    staleTime: LIST_STALE_TIME_MS,
  });
}
